<template>
<div class="col-12 text-left">
    <div class="row">
      <h3 class="p-2">
          <small class="text-muted">Approved Quality - Approval Status</small>
      </h3>
      <div v-if="aq.isApproved" class="col-1 task-completed"></div>
    </div>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
        <div class="form-group col-3">
            <label for="srNumber">SR Number</label>
            <input disabled type="text" class="form-control" v-model="aq.srNumber" id="aqNumber" aria-describedby="code">
        </div>
        <div class="form-group col-3">
            <label>Start Date</label>
            <flat-pickr disabled class="form-control" v-model="aq.startDate"></flat-pickr>
        </div>
        <div class="form-group col-3">
            <label>Due Date</label>
            <flat-pickr disabled class="form-control" v-model="aq.dueDate"></flat-pickr>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-6">
            <label>Product</label>
            <input disabled type="text" class="form-control" id="product" v-model="aq.product">
        </div>
        <div class="form-group col-6">
            <label>Customer</label>
            <input disabled type="text" class="form-control" id="customer" v-model="aq.customer">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-6">
            <label>Destination</label>
            <input disabled type="text" class="form-control" id="destination" v-model="aq.destination">
        </div>
        <div class="form-group col-6">
            <label>Address</label>
            <input disabled type="text" class="form-control" id="address" v-model="aq.address">
        </div>
    </div>
     <div class="row">
         <div class="form-group col-3">
            <label>Schedule Product</label>
            <input disabled type="text" class="form-control" id="address" v-model="aq.scheduleProduct">
        </div>
        <div class="form-group col-3">
            <label>Approved By</label>
            <input type="text" disabled class="form-control" id="approvedBy" v-model="aq.approvedByName">
        </div>
    </div>
    <div class="row">
        <div class="form-group col-12">
            <label for="desc-textarea">Remark</label>
            <textarea disabled class="form-control" id="desc-textarea" v-model="aq.remark" rows="3"></textarea>
        </div>
    </div>
    <app-datatable :type="'view'" :elements="dtElements" :collections="aq.approvedQualityDetail"></app-datatable>
    <button type="button" class="btn btn-outline-danger" @click="close">Close <i class="far fa-window-close"></i></button>
    <br /><br />
</div>
</template>

<script>
import api from '../../services/api'
import { approvedQuality, approvedQualityDetail } from '../../models/approvedQuality'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker
  },
  data() {
    return {
      aq: {
        ...approvedQuality,
        approvedQualityDetail: []
      },
      dtElements: [
        {
            title: 'Spec',
            column: 'spec',
            type: 'text',
            width: 2,
        },
        {
            title: 'Qty',
            column: 'qty',
            type: 'number',
            width: 2,
        },
        {
            title: 'UOM',
            column: 'UOM',
            type: 'text',
            width: 1,
        },
        {
            title: 'Sample Cost / MT',
            column: 'sampleCostMT',
            type: 'number',
            width: 3,
        },
        {
            title: 'Sample Cost',
            column: 'sampleCost',
            type: 'text',
            width: 3,
        },
        {
            title: 'DG',
            column: 'DG',
            type: 'checkbox',
            width: 1,
        },
        {
            title: 'Courier',
            column: 'courier',
            type: 'checkbox',
            width: 1,
        },
        {
            title: 'Paid',
            column: 'paid',
            type: 'checkbox',
            width: 1,
        },
        {
            title: 'Carrier Cost',
            column: 'carrierCost',
            type: 'text',
            width: 2,
        },
        {
            title: 'Courier Information Number',
            column: 'courierInformationNumber',
            type: 'text',
            width: 3,
        },
      ]
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const approveApi = api('approved-quality/approval')
      const payload = {
        id: this.$route.query.id,
        action: this.$route.query.action
      }
      await approveApi.create(payload)
      
      const aqApi = api('approved-quality')
      this.aq = await aqApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    close() {
      this.$router.push({ name: 'approvedQuality' })
    },
    finishLookup(data) {
      const currentSR = this.aq
      this.aq = {
          ...currentAQ,
          ...data
      }
    }
  }
}
</script>